import Vue from 'vue'

const dummyEventBus = {
  $emit() {},
  $on() {},
  $off() {},
}

Vue.prototype.$eventBus = dummyEventBus
